export default [
    {
        component: () => import(/* webpackChunkName: 'ambulatorio-relatorio-estatistico-consulta' */ '@/views/ambulatorio/relatorio-estatistico-consulta/Index'),
        path: 'relatorio-estatistico-consulta',
        redirect: 'relatorio-estatistico-consulta/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-relatorio-estatistico-consulta' */'@/views/ambulatorio/relatorio-estatistico-consulta/List.vue'),
                name: 'ambulatorio-relatorio-estatistico-consulta-index',
                path: 'index',
            },
        ],
    },
]